import { render } from "./SalesCancel.vue?vue&type=template&id=d5b4847a"
import script from "./SalesCancel.vue?vue&type=script&lang=js"
export * from "./SalesCancel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__